import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import shouldPureComponentUpdate from 'react-pure-render/function';

import './OpeningHoursModal.scss';

const mapStateToProps = state => ({
  appState: state.appState,
});

export class OpeningHoursModal extends Component {
  static propTypes = {
    appState: PropTypes.object,
  };

  static defaultProps = {
    appState: Immutable.Map(),
  };

  state = {}

  shouldComponentUpdate = shouldPureComponentUpdate;

  toggleSalesTeamHours = (event) => {
    event.preventDefault();
    this.setState({
      toggleSalesTeamHours: !this.state.toggleSalesTeamHours,
    });
  }

  render() {
    const { appState } = this.props;

    const landlinePhone = appState.get('landlinePhone');

    return (
      <div className="opening-hours-modal">
        { this.state.toggleSalesTeamHours ? (
          <div>
            <h1 className="opening-hours-modal__heading">After Sales Team</h1>
            <a className="opening-hours-modal__number" href="tel:01903 258 288">01903 258 288</a>
            <ul className="opening-hours-modal__list">
              <li className="opening-hours-modal__list__el">
                <span className="opening-hours-modal__list__el__days">Monday to Sunday:</span><span className="opening-hours-modal__list__el__time">9am to 5pm</span>
              </li>
            </ul>

            <div><a href="#" className="opening-hours-modal__view-toggle" onClick={this.toggleSalesTeamHours}>New Booking Information</a></div>
          </div>
        ) : (
          <div>
            <h1 className="opening-hours-modal__heading">New Booking Information</h1>
            { landlinePhone && (
              <a className="opening-hours-modal__number" href={`tel:${landlinePhone}`}>{landlinePhone}</a>
            )}
            <ul className="opening-hours-modal__list">
              <li className="opening-hours-modal__list__el">
                <span className="opening-hours-modal__list__el__days">Monday to Friday:</span><span className="opening-hours-modal__list__el__time">8am to 11pm</span>
              </li>
              <li className="opening-hours-modal__list__el">
                <span className="opening-hours-modal__list__el__days">Saturday:</span><span className="opening-hours-modal__list__el__time">8am to 10pm</span>
              </li>
              <li className="opening-hours-modal__list__el">
                <span className="opening-hours-modal__list__el__days">Sunday:</span><span className="opening-hours-modal__list__el__time">9am to 10pm</span>
              </li>
              <li className="opening-hours-modal__list__el">
                <span className="opening-hours-modal__list__el__days">Bank Holidays:</span><span className="opening-hours-modal__list__el__time">10am to 10pm</span>
              </li>
            </ul>
            <div><a href="#" className="opening-hours-modal__view-toggle" onClick={this.toggleSalesTeamHours}>Customer Service Information</a></div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(OpeningHoursModal);



/** WEBPACK FOOTER **
 ** ./src/components/OpeningHoursModal/OpeningHoursModal.jsx
 **/